import React, { useState } from 'react'
import { Deal } from '../models/shared/Deal'
import { useText } from '../context/TextContext';
import DealModalSection from './DealModalSection';
import DealAttachmentRecord from './DealAttachmentRecord';
import AttachmentPreview from './AttachmentPreview';
import { Attachement } from '../models/shared/Attachment';
import { toast } from 'react-toastify';
import { deleteObject, ref } from 'firebase/storage';
import { useStorage } from 'reactfire';
import { AdvancedButton } from './AdvancedButton';
import { isMobileDevice } from '../utils/logic';

interface Props {
    deal: Deal
    onNewAttachment: (capture: boolean) => void
    onDealUpdate: (update: Partial<Deal>) => Promise<void>;
    className?: string;
    readOnly?: boolean;
}

export default function DealAttachments(props: Props) {
    const { deal } = props
    const text = useText();
    const storage = useStorage();
    const attachments = deal.attachments || [];
    const [previewIndex, setPreviewIndex] = useState<number>(-1)
    const [isPreviewOpen, setIsPreviewOpen] = useState(false)

    if (!attachments.length) {
        return <></>
    }

    const handleDelete = async (index: number, attachment: Attachement) => {
        try {
            const docRef = ref(storage, attachment.path)
            await deleteObject(docRef)

            const newAttachements = attachments.filter((_, i) => i !== index)
            await props.onDealUpdate({ attachments: newAttachements })
        } catch (error) {
            console.error(error)
            toast.error(text.defaultError)
        }
    }

    const handlePreview = (index: number) => {
        setPreviewIndex(index)
        setIsPreviewOpen(true)
    }

    const handleClosePreview = () => {
        setIsPreviewOpen(false)
        setPreviewIndex(-1)
    }

    return (
        <>
            <DealModalSection title={text.attachments} open sizeDependencies={[deal.attachments]}>
                <div className='d-flex flex-column gap-2'>
                    {attachments.map((attachment, index) => <DealAttachmentRecord
                        readonly={props.readOnly}
                        onDelete={() => handleDelete(index, attachment)}
                        onPreview={() => handlePreview(index)}
                        key={index} attachment={attachment} />
                    )}
                    {!props.readOnly && <div className='center gap-2'>
                        {isMobileDevice() && <AdvancedButton onClick={() => props.onNewAttachment(true)} variant='clear' icon='bi-camera' size='sm'>{text.takePhoto}</AdvancedButton>}
                        <AdvancedButton onClick={() => props.onNewAttachment(false)} variant='clear' icon='bi-plus' size='sm'>{text.addAttachment}</AdvancedButton>
                    </div>}
                </div>
            </DealModalSection>

            <AttachmentPreview
                attachments={attachments}
                initialIndex={previewIndex}
                isOpen={isPreviewOpen}
                onClose={handleClosePreview}
            />
        </>
    )
}
